import Modals from 'module.modal'
import { EVENTS } from 'util.events'

class KiteCartPopup extends HTMLElement {
  constructor() {
    super()
    this.modal = null
    this.widgetInitialized = false
    this.autoCloseTimer = null
  }

  connectedCallback() {
    this.modal = new Modals(this.id, 'kite-cart-popup', {
      trapFocus: true
    })

    document.addEventListener(EVENTS.ajaxProductAdded, this.handleProductAdded.bind(this))
  }

  async handleProductAdded(event) {
    // Check if the event aims to trigger the popup (Quick Add / Quick Shop)
    const btn = event.detail ? event.detail.addToCartBtn : null;
    let isQuickAdd = false;

    if (btn) {
        if (btn.hasAttribute('data-single-variant-quick-add')) {
            isQuickAdd = true;
        } 
        else if (btn.closest('quick-add') || btn.closest('quick-shop')) {
            isQuickAdd = true;
        }
        else if (btn.closest('[data-tool-tip-content]')) {
             isQuickAdd = true;
        }
    }
    if (!isQuickAdd) {
        return;
    }

    // Show the modal
    if (this.modal) {
      this.modal.open()
      
      // Initialize/Refresh the Kite widget
      this.initKiteWidget()

      // Auto-close the popup after 3 seconds
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer)
      }
      this.autoCloseTimer = setTimeout(() => {
        this.modal.close()
        this.autoCloseTimer = null
      }, 3000)
    }
  }

  async initKiteWidget() {
    const widgetContainer = this.querySelector('#KiteProgressBarWidget')
    if (!widgetContainer) return

    try {
      // Ensure gfg and gfgConsolidatedCustomDiscount are available
      if (typeof gfg !== 'undefined' && typeof gfgConsolidatedCustomDiscount !== 'undefined') {
        const discounts = (gfg.settings.consolidatedCombinedDiscount || []).filter(
          (d) => d && d.title && d.title.includes('POP_UP_WIDGET') && d.isEnabled !== false && d.isDeleted !== true
        )
        if (!discounts.length) {
          console.warn('Kite Cart Popup: Discount including "POP_UP_WIDGET" not found.')
          return
        }
        // Piu' campagne POP_UP_WIDGET (es. "[BFCM 26] - PF -" e "[BFCM 26] - NO PF -"):
        // loggata = iscritta al Programma Fedelta' -> prima la PF, ospite -> prima la NO PF.
        // Se Kite non inizializza quella scelta, si prova la successiva.
        const isMember = this.dataset.customer === 'member'
        const isNoPf = (d) => /\bNO[\s_-]*PF\b/i.test(d.title)
        const isPf = (d) => !isNoPf(d) && /\bPF\b/i.test(d.title)
        const rank = (d) => (isMember ? (isPf(d) ? 0 : isNoPf(d) ? 2 : 1) : (isNoPf(d) ? 0 : isPf(d) ? 2 : 1))
        const ordered = discounts.slice().sort((a, b) => rank(a) - rank(b))

        const ccd = gfgConsolidatedCustomDiscount
        const pb = ccd.gfgProgressBar
        // Kite ha migrato le campagne (widgetsMigratedAt): non esiste piu' il posizionamento POP_UP e
        // initialize() chiama prepareProgressBarUI che non c'e' piu'. Si disegna la barra con il nuovo
        // percorso (buildNormalizedInput + gfgGlobalWidgets.progressBar.render) usando la configurazione
        // della pagina carrello; checkIfWidgetShouldBeVisible decide quale campagna vale per la cliente.
        const canRenderNew = pb && pb.f && typeof pb.f.buildNormalizedInput === 'function' && typeof pb.f.getWidget === 'function'
          && typeof gfgGlobalWidgets !== 'undefined' && gfgGlobalWidgets.progressBar && typeof gfgGlobalWidgets.progressBar.render === 'function'

        if (canRenderNew) {
          const cartData = await gfg.utility.getCartV2({ forceRefresh: true })
          pb.state.cartData = cartData
          try { await gfg.customDiscountValidationFunctions.getLatestCartItemsProductData(cartData) } catch (e) {}
          for (const discount of ordered) {
            try {
              const placement = pb.f.getWidget(discount, 'CART_PAGE') ? 'CART_PAGE' : 'PRODUCT_PAGE'
              const widget = pb.f.getWidget(discount, placement)
              if (!widget) continue
              const visible = await ccd.f.checkIfWidgetShouldBeVisible(discount, placement)
              if (!visible) continue
              const progress = pb.f.calculateProgress(discount, cartData)
              const input = pb.f.buildNormalizedInput(discount, widget, progress, 'POP_UP', cartData)
              const el = gfgGlobalWidgets.progressBar.render(input)
              if (el) {
                widgetContainer.innerHTML = ''
                widgetContainer.appendChild(el)
                this.widgetInitialized = true
                return
              }
            } catch (err) {
              console.warn('Kite Cart Popup: "' + discount.title + '" non disegnata, provo la successiva.', err)
            }
          }
        }

        // Vecchio metodo (versioni di Kite precedenti alla migrazione)
        for (const discount of ordered) {
          try {
            const progressBarWidget = await pb.initialize(discount, 'POP_UP')
            if (progressBarWidget && progressBarWidget.generatedUI) {
              widgetContainer.innerHTML = ''
              widgetContainer.appendChild(progressBarWidget.generatedUI)
              this.widgetInitialized = true
              return
            }
          } catch (err) {
            console.warn('Kite Cart Popup: "' + discount.title + '" non inizializzata (metodo vecchio).', err)
          }
        }
        console.warn('Kite Cart Popup: nessuna campagna POP_UP_WIDGET inizializzata.')
      } else {
        console.error('Kite Cart Popup: Kite app (gfg) not loaded.')
      }
    } catch (error) {
      console.error('Kite Cart Popup: Error initializing widget:', error)
    }
  }
}

if (!customElements.get('kite-cart-popup')) {
  customElements.define('kite-cart-popup', KiteCartPopup)
}